export type ApprovalChoice = "create" | "reject";

export function approvalChoiceUserText({
  choice,
  mode,
}: {
  choice: ApprovalChoice;
  mode: "create" | "update";
}): string {
  if (choice === "reject") return "Reject";
  return mode === "create" ? "Create" : "Update";
}
